module.exports = __webpack_public_path__ + "static/assets/7a23d72cb8d94f79b1d3b62d4ea71bfe.svg";